import { useAPIAction, ImagesDraftApi } from "melco-shared-logic";

export const useBlankPictureUpload = () => {
  const [uploadBlankPicture] = useAPIAction(
    ImagesDraftApi,
    async (api, file: Blob) => {
      const data = await api.userImageUploadDraft({
        file,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "blank_pictures.actions.upload",
    }
  );

  return {
    uploadBlankPicture,
  } as const;
};
